<template>
    <el-container class="layout">
        <el-header class="layout-header">
            <div class="logo">
                <img src="../../assets/images/logo.png" alt="" />
            </div>
            <div class="right">
                <el-popover placement="bottom" trigger="hover">
                    <div class="logout" @click="logout()">Log out</div>
                    <div class="account" slot="reference">
                        {{ userInfo.account }}
                    </div>
                </el-popover>
            </div>
        </el-header>
        <el-container class="layout-container">
            <el-aside class="layout-aside" width="210px"><Menu /></el-aside>

            <el-main class="layout-main">
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import Menu from "../../components/Menu";
import { mapGetters } from "vuex";

export default {
    name: "Layout",
    components: {
        Menu,
    },
    computed: {
        ...mapGetters({
            userInfo: "getUserInfo",
            lang: "getLang",
        }),
    },
    data() {
        return {
            activeMenu: "prompt",
            langMap: {
                en: "English",
                zh: "简体中文",
            },
        };
    },

    methods: {
        handleMenuSelect(index) {
            this.activeMenu = index;
        },
        handleLang(command) {
            this.$store.commit("setLang", command);
        },
        logout() {
            window.localStorage.clear();
            window.location.href = "/login";
        },
    },
};
</script>

<style scoped lang="scss">
.layout {
    border: 1px solid #eaeaea;
    height: 100vh;
}

.layout-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eaeaea;
    padding: 10px;
}

.logo {
    font-size: 24px;
    font-weight: bold;

    img {
        height: 26px;
    }
}

.right {
    display: flex;
    align-items: center;
}

.account {
    font-size: 16px;
    margin-left: 20px;
    cursor: pointer;
}

.layout-container {
    height: calc(100vh - 60px);
}

.layout-aside {
    border-right: 1px solid #eaeaea;
}

.layout-main {
    padding: 20px;
    max-height: calc(100vh - 60px);
    overflow-y: auto;
}

.el-menu-item.is-active {
    background-color: #1890ff;
    color: #fff;
}

.menu-vertical .el-menu-item {
    display: block;
}

.el-dropdown-link {
    cursor: pointer;
}
.logout {
    text-align: center;
    cursor: pointer;
    &:hover {
        color: #409eff;
    }
}
</style>
